const dev = {
  baseURL: 'http://localhost:5000',
  sender_number: '447778845083',
  uploaded_file_url: 'https://d30mz8uskc8fpf.cloudfront.net',
  aws_bucket: 'magna-promotions',
  env: 'uat',
};
const uat = {
  baseURL: 'https://uat-api.wacustomercare.com',
  sender_number: '447778845083',
  uploaded_file_url: 'https://d30mz8uskc8fpf.cloudfront.net',
  aws_bucket: 'magna-promotions',
  salt: 'wbJHcg8g8e5hF1ERCEzMrqbc8ZwEzCS4an8hmtursSk=',
  env: 'uat',
};

const prod = {
  baseURL: 'https://prod-api.wacustomercare.com',
  sender_number: '447778845083',
  uploaded_file_url: 'https://d30mz8uskc8fpf.cloudfront.net',
  aws_bucket: 'magna-promotions',
  salt: 'wbJHcg8g8e5hF1ERCEzMrqbc8ZwEzCS4an8hmtursSk=',
  env: 'prod',
};

module.exports = prod;